import Icon from "../../../../../../components/icons";

export const iconMap = {
    'Uzun Far': <Icon.HighBeam />,
    'Kısa Far': <Icon.LowBeam />,
    'Klima': <Icon.ACC />,
    'Dönüş Sinyalleri': <Icon.TurnSignals />,
    'Tehlike Uyarısı': <Icon.DangerAlert />,
    'Engelliler için Anlam': <Icon.DisabledPeople />,
    'El Freni': <Icon.HandBrake />,
    'Fren Arızası': <Icon.BrakeFailure />,
    'Tavan Kapağı': <Icon.CeilingCover />,
    'Yakıt Seviyesi': <Icon.FuelLevel />,
    'Motor Soğutma Suyu Sıcaklığı': <Icon.EngineCoolantLevel />,
    'Akıllı Şarj Durumu': <Icon.CleverCharge />,
    'Motor Yağı': <Icon.EngineOil />,
    'Pozisyon Lambaları & Yan Lambalar': <Icon.PositionSideLambs />,
    'Ön Sis Lambaları': <Icon.FrontFogLamp />,
    'Arka Sis Lambaları': <Icon.BackFogLamp />,
    'Park Isıtma': <Icon.ParkingHeating />,
    'Motor / MI Göstergesi': <Icon.EngineEmissionSystemMalfunction />,
    'Servis & Bakım': <Icon.ServiceRepair />,
    'Şanzıman Sıvısı': <Icon.TransmissionFluidTemperature />,
    'Şanzıman Hatası': <Icon.GearboxFailure />,
    'ABS Arızası': <Icon.AbsTrailer12 />,
    'Aşınmış Fren Balataları' : <Icon.WornBrakeFailure />,
    'Ön Cam Yıkama Sıv.' : <Icon.WornBrakeFailure />,
    'Lastik Arızası': <Icon.TireFailure />,
    'Arıza/Genel Arıza' : <Icon.ServiceRepair />,
    'Motor Yağı Sıcaklığı' : <Icon.EngineOilTemprature />,
    'Motor Yağı Seviyesi' : <Icon.EngineOil />,
    'Motor Soğutma Suyu Seviyesi' : <Icon.TransmissionFluidTemperature />,
    'Direksiyon Sıvısı Seviyesi': <Icon.SteeringFluidLevel />,
    'Direksiyon Arızası': <Icon.SteeringFluidLevel />,
    'Yükseklik Kontrolü': <Icon.HeightControl />,
    'Retarder': <Icon.Retarder />,
    'Motor Emisyon Sis. Arz.' : <Icon.EngineEmissionSystemMalfunction />,
    'ESC Göstergesi' : <Icon.EscClosed />,
    'Fren Lambası': <Icon.BrakeLights />,
    '1. Körük' : <Icon.ArticulatedVehicle />,
    'Durma Talebi': <Icon.StopRequest />,
    'Çocuk Arabası İsteği': <Icon.BabyCar />,
    'Otobüs Durağı Freni': <Icon.BusStopBrake />,
    'Adblue Seviyesi': <Icon.AdBlue />,
    'Kaldırma': <Icon.Kneeling />,
    'Düşürme': <Icon.Lowering />,
    'Alçaltma': <Icon.Kneeling />,
    'Yardımcı Hava Basıncı': <Icon.AirPressureLev />,
    'Hava Filtresi': <Icon.AirFilter />,
    'Yakıt Filtresi Fark Basıncı': <Icon.FuelFilterDifferentialPressure />,
    'Emniyet Kemeri': <Icon.SafetyBelt />,
    'EBS' : <Icon.Ebs />,
    'Şeritten Ayrılma Göstergesi': <Icon.LaneOff />,
    'Gelişmiş Acil Durum Fren Sis.': <Icon.EmergencyBrakingSystem />,
    'ACC': <Icon.Acc />,
    'Römork Bağlandı' : <Icon.ParkingHeating />,
    'ABS Trailer 1-2': <Icon.AbsTrailer12 />,
    'Airbag': <Icon.Airbag />,
    'EBS Trailer 1-2': <Icon.Airbag />,
    'Takograf Göstergesi': <Icon.TacoGraphy />,
    'ESC Göstergesi Kapalı': <Icon.EscClosed />,
    'Şeritten Ayrılma Gös. Kapalı': <Icon.LaneOff />,
    'Engine Emission Filter': <Icon.CloseCircle />,
    'Elektrik Motoru Arızaları': <Icon.CloseCircle />,
    'Adblue Tahrifat': <Icon.CloseCircle />,
    'Multipleks Sistemi': <Icon.CloseCircle />,
    'Motor Bölmesi Sıcaklığı': <Icon.CloseCircle />,
};
